/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { destinationsListAttempts } from "../../funcs/destinationsListAttempts.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListTenantDestinationAttemptsRequest$inboundSchema,
};

export const tool$destinationsListAttempts: ToolDefinition<typeof args> = {
  name: "destinations-list-attempts",
  description: `List Destination Attempts

Retrieves a paginated list of attempts scoped to a specific destination.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await destinationsListAttempts(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
